import { FC, ReactNode } from "react";
import { AppText } from "components";
import styled from "styled-components";
import { colors, currencyIcons } from "helpers/consts";

interface CoinCellProps {
  coin?: string;
  icon?: ReactNode;
  text?: string;
  subText?: string;
  minWidth?: string;
  darkTheme?: boolean;
  coinSize?: string;
  gap?: string;
}

const CoinCell: FC<CoinCellProps> = ({
  coin,
  text,
  subText,
  minWidth,
  icon,
  darkTheme,
  coinSize,
  gap,
}) => {
  return (
    <RowCoinCell $minWidth={minWidth} $coinSize={coinSize} $gap={gap}>
      {icon ? (
        icon
      ) : coin ? (
        coin === "empty" ? (
          <EmptyCoin $coinSize={coinSize} />
        ) : currencyIcons[coin] ? (
          currencyIcons[coin]
        ) : (
          currencyIcons.not_found
        )
      ) : (
        currencyIcons.not_found
      )}
      <RowInfoCell>
        <AppText color={darkTheme ? colors.gray_200 : colors.gray_900}>
          {text || ""}
        </AppText>
        {subText && (
          <AppText isSpan color={colors.gray_600} fontWeight={400}>
            {subText}
          </AppText>
        )}
      </RowInfoCell>
    </RowCoinCell>
  );
};

interface RowCoinCellProps {
  $minWidth?: string;
  $coinSize?: string;
  $gap?: string;
}
const RowCoinCell = styled.div<RowCoinCellProps>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${({ $minWidth }) => $minWidth && `min-width: ${$minWidth};`}

  & > *:not(:first-child) {
    margin-left: ${({ $gap }) => ($gap ? $gap : "1.2rem")};
  }

  svg {
    min-width: ${({ $coinSize }) => ($coinSize ? $coinSize : "4.8rem")};
    max-width: ${({ $coinSize }) => ($coinSize ? $coinSize : "4.8rem")};
    min-height: ${({ $coinSize }) => ($coinSize ? $coinSize : "4.8rem")};
    max-height: ${({ $coinSize }) => ($coinSize ? $coinSize : "4.8rem")};
  }

  @media (min-width: 36em) {
    & > *:not(:first-child) {
      margin-left: ${({ $gap }) => ($gap ? $gap : "2rem")};
    }
  }
`;

const RowInfoCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
`;

interface EmptyCoinProps {
  $minWidth?: string;
  $coinSize?: string;
  $gap?: string;
}
const EmptyCoin = styled.div<EmptyCoinProps>`
  min-width: ${({ $coinSize }) => ($coinSize ? $coinSize : "4.8rem")};
  min-height: ${({ $coinSize }) => ($coinSize ? $coinSize : "4.8rem")};
  max-height: ${({ $coinSize }) => ($coinSize ? $coinSize : "4.8rem")};
  max-width: ${({ $coinSize }) => ($coinSize ? $coinSize : "4.8rem")};
`;

export default CoinCell;
